module.exports = __webpack_public_path__ + "static/media/Path Copy.ffd73659.png";